import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { Alert, Spinner } from 'react-bootstrap';
import { contactAttributeSliceAction } from '../../store/contactAttributeSlice';
import { RiSave3Fill, RiCloseCircleLine } from "react-icons/ri";
import { chatSliceAction } from "../../store/chatSlice"
import { agentSliceAction } from "../../store/agentSlice";

const Wrapup = () => {
    const dispatch = useDispatch()
    const contactAttributes = useSelector((state:any)=>{return state.contactAttributeSlice?.contactAttributes})
    const selectedContactId = useSelector((state:any)=>{return state.contactAttributeSlice?.selectedContact})
    const selectedContact = contactAttributes?.filter((item:any) => item.contactId === selectedContactId)[0]
    let wrapupCodes = selectedContact?.wrapupData?.wrapupCodes
    let subAccounts = selectedContact?.wrapupData?.subAccounts
    const timerRef = useRef<any>(null);

    const [ticketNumber, setTicketNumber] = useState("")
    const [wrapupCode, setWrapupCode] = useState("")
    const [subAccount, setSubAccount] = useState("")
    const [ticketErrorMessage, setTicketErrorMessage] = useState("")
    const [warpupCodeErrorMessage, setWarpupCodeErrorMessage] = useState("")
    const [subAccountErrorMessage, setSubAccountErrorMessage] = useState("")
    const [isDisabled, setIsDisabled] = useState(false)
    const [alertDisplay, setAlertDisplay] = useState(false)


    const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj })
    const agentSnapshot = useSelector((state: any) => { return state.agentSlice.agentSnapshot })
    const agentState = agentSnapshot?.agentData?.snapshot?.agentAvailabilityState?.state;
    const [agentStates, setAgentStates] = useState<any>("");

    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);

    const onChangeTicketNumber = (event:any) => {
        setTicketErrorMessage("")
        setTicketNumber(event.target.value)
    } 

    const onChangeWrapupCode = (event:any) => {
        setWarpupCodeErrorMessage("")
        setWrapupCode(event.target.value)
    }

    const onChangeSubAccount = (event:any) => {
        setSubAccountErrorMessage("")
        setSubAccount(event.target.value)
    }

    const onSaveWrapupCode = () => {
        
        if(ticketNumber === "" || ticketNumber.length > 149) {
            setTicketErrorMessage("Enter ticket number")
            return false;
        } else if(wrapupCodes?.length > 0 && wrapupCode === "") {
            setWarpupCodeErrorMessage("Select wrap-up code")
            return false;
        } else if(subAccount === "" && selectedContact?.accountName === "Mobox") {
            setSubAccountErrorMessage("Select sub account")
            return false;
        }

        let finalTicketNumber = ticketNumber;
        if (process.env.REACT_APP_AWS_CCP_REGION === "eu-west-2" && /^\d*$/.test(ticketNumber)) {
			finalTicketNumber = "INC-" + ticketNumber;
		}

        let requestData:any = {
            contact_id : selectedContact?.contactId,
            ticket_number : finalTicketNumber,
            contactDirection : selectedContact?.contactDirection,
        }
        if(selectedContact?.contactDirection === 'outbound') {
            if (subAccount) requestData.ob_account = subAccount;
            if (selectedContact.accountName === "Mobox") requestData.ob_country_code = parsePhoneNumberFromString(selectedContact.phone)?.countryCallingCode.toString()
            if (wrapupCode) requestData.ob_wrapcode = wrapupCode;
        } else if (selectedContact?.contactDirection === 'inbound') {
            if (wrapupCode) requestData.ib_wrapcode = wrapupCode;
        }
        if(selectedContact?.contactId) {
            setIsDisabled(true)
            fetch(process.env.REACT_APP_API_GETWAY_URL + "set-wrap-code", {
                method: "POST",
                body: JSON.stringify(requestData),
            }).then(resp => {
                if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
                return resp.json();
            }).then(resp => {
                if (!resp.success) throw new Error("API returned failure code!");
                let responseTicket = resp?.new_attrs?.TicketNumber;
                let updatedAttributes = contactAttributes.map((item:any) => {
                    let temp = Object.assign({}, item);
                    if(item.contactId === selectedContact?.contactId) {
                        temp.isTicketNumberAssign = true;
                        temp.contactAttributes = Object.assign({}, item.contactAttributes, { 'TicketNumber':{'value':responseTicket}})
                    }
                    return temp;
                });
                dispatch(contactAttributeSliceAction.updateContactAttributes(updatedAttributes))
                setAlertDisplay(true)
                timerRef.current = setTimeout(() => setAlertDisplay(false), 5000);
                setTicketNumber("")
                setIsDisabled(false)
                return;
            });
        }
    }

    const onCloseContact = () => {
        if(selectedContact?.contactId) {
            const remainingContact = contactAttributes.filter((item:any) => item.contactId !== selectedContact?.contactId)
            if(remainingContact.length > 0) {
                dispatch(contactAttributeSliceAction.removeContactAttributes(remainingContact))
            } else {
                dispatch(contactAttributeSliceAction.removeContactAttributes(remainingContact))
            }
            dispatch(contactAttributeSliceAction.setSelectedContact(""))
        }
    }


    const onAgentStatusChange = (status: any) => {{
        setAgentStates(agentObj.getAgentStates());
        let availableState: any;
        for(const state of agentStates){
            if(state.name === "Available"){
                availableState = state;
            }
        }

          

        dispatch(chatSliceAction.changeisEmailMissed({ isEmailMissed: false }));
        dispatch(chatSliceAction.changeisEmailRejected({ isEmailRejected: false }));
        dispatch(chatSliceAction.changeIsItRejected({ isItRejected: false }));
        dispatch(chatSliceAction.changeIsItMissed({ isItMissed: false }));

            if (agentState !== status) {
                document.title = `[${agentState}] Fujitsu Connect`;
                
                agentObj.setStatus(availableState, {
                    success: () => {
                        
                        let existingValues = localStorage.getItem("agentStateTimer");
                        
                        if (existingValues){
                        let existingData = JSON.parse(existingValues);
                        existingData[`StartTime${availableState.name}`] = Math.floor(Date.now()/1000)

                        if (!existingData[availableState.name+"used"]||existingData[availableState.name+"used"]>0){
                            existingData[availableState.name+"used"]+= existingData[availableState.name] 
                        } 
                        if (!existingData[agentState+"used"]){
                            existingData[agentState+"used"]+= existingData[agentState]
                            existingData[agentState] = 0
                        }

                        localStorage.setItem("agentStateTimer", JSON.stringify(existingData))
                        }
                        console.log("Agent Status Change Successfully -" + availableState.name)
                    },
                    failure: () => {
                        console.log("Agent Status Change Failed -" + availableState.name)
                    }
                    
                },
                    { enqueueNextState: true })

            }
            dispatch(agentSliceAction.setMonitoring({isMonitoring: false}));
        }
    }

    return (
        <div className="card wrapup-box collapse show mt-3" id="wrapup">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>Wrap-up ({wrapupCodes?.length ?? 0})</h6>
            </div>
            <div className="card-body height-400">
                <form onSubmit={e => e.preventDefault()} onKeyPress={(e)=>{if (e.key ==="Enter"){onSaveWrapupCode()}}}>
                    {alertDisplay &&
                        <Alert variant="success" onClose={() => setAlertDisplay(false)} dismissible>
                            <strong>Data saved successfully</strong>
                        </Alert>
                    }
                    <div className="form-group mb-3">
                        <label className='mb-2'>Ticket number</label>
                        <input maxLength={149} onChange={(event) => { onChangeTicketNumber(event) }} value={ticketNumber} type="text" className={`form-control ${(ticketErrorMessage !== "")?"is-invalid":""}`}  placeholder='Enter ticket number' />
                        {ticketErrorMessage && <div className="invalid-feedback">Enter ticket number</div>}
                    </div>
                    {wrapupCodes?.length > 0 && 
                        <div className="form-groupc">
                            <label className='mb-2'>Wrap-up code</label>
                            <select onChange={(event) => { onChangeWrapupCode(event) }} className={`form-control ${(warpupCodeErrorMessage !== "")?"is-invalid":""}`}>
                                <option>-----</option>
                                {wrapupCodes.map((code:any, index:number) => {
                                    return (<option key={index}>{code}</option>)
                                })}
                            </select>
                            {warpupCodeErrorMessage && <div className="invalid-feedback">Select wrap-up code</div>}
                        </div>
                    }
                    {subAccounts?.length > 0 && 
                        <div className="form-group mb-3">
                            <label className='mb-2'>Account</label>
                            <select onChange={(event) => { onChangeSubAccount(event) }} className={`form-control ${(subAccountErrorMessage !== "")?"is-invalid":""}`}>
                                <option>-----</option>
                                {subAccounts.map((code:any, index:number) => {
                                    return (<option key={index}>{code}</option>)
                                })}
                            </select>
                            {subAccountErrorMessage && <div className="invalid-feedback">Select account</div>}
                        </div>
                    }
                    <button onClick={()=>{ onSaveWrapupCode(); if(agentState === "Forgot WrapCode"){onAgentStatusChange("Available")} }} disabled={isDisabled} type="button" className="form-control btn btn-primary mt-3">
                        {isDisabled && <Spinner as="span"animation="grow" size="sm" role="status" aria-hidden="true"/>}
                        <RiSave3Fill /> Save
                        
                    </button>
                    <button onClick={()=>{ onCloseContact() }} disabled={!selectedContact?.isTicketNumberAssign} type="button" className="form-control btn btn-danger mt-3"><RiCloseCircleLine /> Close contact</button>
                </form>
            </div>
        </div> 
    )
}
export default Wrapup;